import { Space } from 'antd';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import Button from 'ui/base/Button';

const Footer = ({ showSavePreferences, onAcceptAll, onAcceptEssential, onPreferencesChange, onPreferencesSave }) => (
  <div className="d-flex justify-content-between">
    <Space>
      {!showSavePreferences && (
        <>
          <Button onClick={onPreferencesChange} data-cy="cookies-set-preferences" className="mr-2">
            <FormattedMessage id="cookies.preferences" defaultMessage="Set preferences" />
          </Button>
          <Button onClick={onAcceptEssential} data-cy="cookies-accept-essential">
            <FormattedMessage id="cookies.onlyEssential" defaultMessage="Only essential" />
          </Button>
        </>
      )}
    </Space>
    <Space>
      {showSavePreferences && (
        <Button onClick={onPreferencesSave} data-cy="cookies-save-preferences" className="mr-2">
          <FormattedMessage id="cookies.savePreferences" defaultMessage="Save Preferences" />
        </Button>
      )}
      <Button type="primary" onClick={onAcceptAll} data-cy="cookies-accept-all">
        <FormattedMessage id="cookies.acceptAll" defaultMessage="Accept all" />
      </Button>
    </Space>
  </div>
);

export default Footer;
